import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';
import TimeSheetModel from '@/models/entities/TimeSheetModel';
import type { SummarySpec } from '@/models/summaries';

/**
 * Total d'une feuille (GET /time_sheet_summaries, lecture seule, lisible comme la feuille) : nombre de lignes et minutes,
 * tenus par l'API. Ressource à part entière (comme les *Summary d'Igienair) : la feuille ne le porte pas, l'écran le
 * demande pour sa page (fetchSummaries, filtre timeSheet[]=…) ; timeSheet réduit à son identité.
 */
export default class TimeSheetSummaryModel extends AbstractApiModel {
  protected _path = '/time_sheet_summaries/{?id}';

  declare _tsFilters: { timeSheet?: id | id[] };

  @doc.model(() => TimeSheetModel) declare timeSheet: TimeSheetModel;
  @doc.number declare timeEntryCount: number;
  @doc.number declare totalMinutes: number;
}

/** Résumés des feuilles : TimeSheetModel.timeSheetSummary */
export const TIME_SHEET_SUMMARIES: SummarySpec = {
  model: TimeSheetSummaryModel,
  parent: 'timeSheet',
  property: 'timeSheetSummary',
};
